const sort = () => {
    const sort = document.querySelector(".projects__sort.sort");
    if (sort) {
        const sortTitle = document.querySelector(".sort__title");
        const sortInput = document.getElementById("filters__sort-input");
        const formSubmit = document.querySelector(".filters__submit");
        sort.addEventListener("click", function(e) {
            if (e.target.dataset.hasOwnProperty("value")) {
                sortTitle.innerText = e.target.innerText;
                sortInput.value = e.target.dataset.value;
                formSubmit.click();
            }
            else if (!e.target.dataset.hasOwnProperty("value") || e.target.dataset.hasOwnProperty("close")) {
                this.classList.toggle("open");
            }
        });
    }
}
export default sort;